module.exports = __webpack_public_path__ + "static/media/bofa_logo.e59e139d.svg";